import React from "react";
import {PageContainer} from "BaseComponents/Wrappers";
import MapBlocksToComponents from "Helpers/BlockHelper";
import {PageTransition} from "Animations";
import {H1} from "BaseComponents/Text/";
import {FlexContainer} from "BaseComponents/Flex";

let ElementPage = ({ Heading, Breadcrumbs, ElementArea }) => {
	return (
		<>
			 {/*<BreadcrumbsComp Items={Breadcrumbs} />*/}
			<PageContainer>
				<FlexContainer
					column
					maxwidth="1280px"
					margin="0 auto"
					padding="0 1rem"
					smallwidth="auto"
				>
					{Heading && <H1 margin="0 0 20px 0">{Heading}</H1>}
				</FlexContainer>
			</PageContainer>
			<PageTransition>
				{ElementArea.length > 0 && MapBlocksToComponents(ElementArea)}
			</PageTransition>
		</>
	);
};
export default ElementPage;
